export default __webpack_public_path__ + "static/03-b-underline-quality-f11a11f668755108d902dfcd51f4fd28.svg";